/**
 * Shared types for the loads table components.
 * Used by both load-hub and agentic-hub consumers.
 */

export type SortDir = 'none' | 'asc' | 'desc'

export type SortColumn = 'rate' | 'rpm' | 'age' | 'dhO' | 'dhD'

export interface LoadsTableSort {
    rate: SortDir
    rpm: SortDir
    age: SortDir
    dhO: SortDir
    dhD: SortDir
}

export const DEFAULT_SORT: LoadsTableSort = {
    rate: 'none',
    rpm: 'none',
    age: 'desc',
    dhO: 'none',
    dhD: 'none',
}

// ── Reorderable data columns ────────────────────────────────────────────────
// The columns a user may drag to reorder (agentic-hub opt-in via `reorderableColumns`). Structural
// columns are deliberately excluded and stay fixed: the leading class-icon / # / pin, and the
// trailing row-actions / star / close (the last is sticky). The array below is the default order —
// identical to the current hardcoded layout, so consumers that pass no order render unchanged.
export type LoadColumnId =
    | 'age'
    | 'status'
    | 'src'
    | 'rate'
    | 'rpm'
    | 'miles'
    | 'map'
    | 'origin'
    | 'dhO'
    | 'destination'
    | 'dhD'
    | 'equipment'
    | 'company'
    | 'contact'

export const DEFAULT_LOAD_COLUMN_ORDER: LoadColumnId[] = [
    'age',
    'status',
    'src',
    'rate',
    'rpm',
    'miles',
    'map',
    'origin',
    'dhO',
    'destination',
    'dhD',
    'equipment',
    'company',
    'contact',
]
